import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { DataResponseHttp } from '../../../../http-models/data-response.http';
import { HospitalQueryHttp } from '../../../../http-models/systems/hospital/hospital-query.http';
import { HospitalHttp } from '../../../../http-models/systems/hospital/hospital.http';
import { StatusResponseHttp } from '../../../../http-models/status-response.http';
import { HospitalLiteQueryHttp } from '../../../../http-models/systems/hospital/hospital-lite-query.http';

@Injectable({
    providedIn: 'root',
})
export class HospitalHttpService {
    private readonly _httpClient = inject(HttpClient);

    getPaginated(
        params: string
    ): Observable<DataResponseHttp<HospitalQueryHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}${params}`;
        return this._httpClient.get<DataResponseHttp<HospitalQueryHttp>>(url);
    }

    getLitePaginated(
        params: string
    ): Observable<DataResponseHttp<HospitalLiteQueryHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}/lite${params}`;
        return this._httpClient.get<DataResponseHttp<HospitalLiteQueryHttp>>(url);
    }

    getById(id: number): Observable<DataResponseHttp<HospitalHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}/${id}`;
        return this._httpClient.get<DataResponseHttp<HospitalHttp>>(url);
    }

    post(request: FormData): Observable<DataResponseHttp<HospitalHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}`;
        return this._httpClient.post<DataResponseHttp<HospitalHttp>>(
            url,
            request
        );
    }

    put(request: FormData): Observable<DataResponseHttp<HospitalHttp>> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}`;
        return this._httpClient.put<DataResponseHttp<HospitalHttp>>(
            url,
            request
        );
    }

    delete(id: number): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}/${id}`;
        return this._httpClient.delete<StatusResponseHttp>(url);
    }

    deletePictureCollapsed(id: number): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}/${id}/picture-collapsed`;
        return this._httpClient.delete<StatusResponseHttp>(url);
    }

    deletePictureExpanded(id: number): Observable<StatusResponseHttp> {
        const url = `${environment.api.baseAddress}${environment.api.system.hospitals}/${id}/picture-expanded`;
        return this._httpClient.delete<StatusResponseHttp>(url);
    }
}
